import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Alert, Collapse} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

// Warning displayed when the connection is lost or too slow and the service worker (public/sw.js) therefore
// served data files downloaded during a previous visit: says from when the oldest of them dates.
export default function OfflineNotice() {
    const [cachedAt, setCachedAt] = useState(null)
    const [open, setOpen] = useState(false)
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!('serviceWorker' in navigator)) return
        const onMessage = (event) => {
            if (!event.data || event.data.type !== 'stale-data' || !event.data.cachedAt) return
            setCachedAt(previous => !previous || event.data.cachedAt < previous ? event.data.cachedAt : previous)
            setOpen(true)
        }
        navigator.serviceWorker.addEventListener('message', onMessage)
        return () => navigator.serviceWorker.removeEventListener('message', onMessage)
    }, [])

    return (
        <Collapse in={open && Boolean(cachedAt)}>
            <Alert
                severity="warning"
                action={
                    <IconButton aria-label="close" color="inherit" size="small" onClick={() => setOpen(false)}>
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
            >
                {t('alert.stale_data', {date: cachedAt ? new Date(cachedAt).toLocaleString(i18n.language, {dateStyle: 'medium', timeStyle: 'short'}) : ''})}
            </Alert>
        </Collapse>
    )
}
